export const BO_LABEL = {
	'-1003': 'customer',
	'-1007': 'visitor',
};
